import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Template } from "../_types/template";
import { Observable } from "rxjs";
import { TemplateVariables } from "../_types/template-variable";

@Injectable({
    providedIn: 'root',
})
export class TemplatesVariablesService extends Service<TemplateVariables> {
    public override type = 'templateVariables';
    public override url = 'communications/templateVariables';
}
